import { PureComponent } from 'react';
import classNames from 'classnames';

import { ANIMATION, mobileAnimation } from 'Lib/animation';

import BottomNav from 'Containers/NavBar/BottomNav';
import TopNav from 'Containers/NavBar/TopNav';
import PageTransition from 'Components/PageTransition';

const { initial, fade, zoom, slideUp, fromLeft } = mobileAnimation;

const animationMapping = {
  [`${initial}-to-${initial}`]: ANIMATION.none,
  [`${fade}-to-${fade}`]: ANIMATION.fadeOut,

  [`${initial}-to-${fade}`]: ANIMATION.fadeIn,
  [`${fade}-to-${initial}`]: ANIMATION.fadeOut,

  // Slide up
  [`${fromLeft}-to-${slideUp}`]: ANIMATION.slideInUp,
  [`${initial}-to-${slideUp}`]: ANIMATION.slideInUp,
  [`${slideUp}-to-${initial}`]: ANIMATION.slideOutDown,
  [`${slideUp}-to-${fromLeft}`]: ANIMATION.slideOutDown,

  // fade
  [`${slideUp}-to-${slideUp}`]: ANIMATION.fadeIn,
  [`${fade}-to-${slideUp}`]: ANIMATION.fadeIn,
  [`${slideUp}-to-${fade}`]: ANIMATION.fadeIn,

  [`${initial}-to-${fromLeft}`]: ANIMATION.slideInLeft,
  [`${fade}-to-${fromLeft}`]: ANIMATION.slideInLeft,
  [`${fromLeft}-to-${initial}`]: ANIMATION.slideOutLeft,
  [`${fromLeft}-to-${fade}`]: ANIMATION.slideOutLeft,

  // special case
  [`${initial}-to-${zoom}`]: ANIMATION.zoomIn,
  [`${zoom}-to-${initial}`]: ANIMATION.fadeOut,
};

const defaultTopNav = <TopNav />;
const defaultBottomNav = <BottomNav />;

type Props = {
  animation: number;
  bottomNav?: React.ReactElement;
  component: React.ComponentType<any>;
  isDesktopCard?: boolean;
  keyName: string;
  navbarPosition?: string;
  onDidMount?: VoidFunction;
  pageProps?: any;
  pathname: string;
  showBackground: boolean | null;
  topNav?: React.ReactElement | null;
};

type State = {
  animation: number;
  enter: boolean;
  exit: boolean;
  pageTransitionClassName?: string;
};

class Main extends PureComponent<Props, State> {
  static defaultProps = {
    bottomNav: defaultBottomNav,
    showBackground: false,
    topNav: defaultTopNav,
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    const current = prevState.animation;
    const next = nextProps.animation;

    const animation: any = animationMapping[`${current}-to-${next}`];

    if (!animation && current === next) {
      return null;
    }

    if (animation) {
      return {
        ...animation,
        animation: next,
      };
    }
    return {
      animation: initial,
      enter: false,
      exit: false,
      pageTransitionClassName: undefined,
    };
  }

  state = {
    animation: initial,
    enter: false,
    exit: false,
    pageTransitionClassName: undefined,
  };

  render() {
    const {
      bottomNav,
      component,
      keyName,
      pageProps,
      pathname,
      showBackground,
      topNav,
      ...others
    } = this.props;
    const Component = component;

    return (
      <>
        <PageTransition
          enter={this.state.enter}
          exit={this.state.exit}
          pageTransitionClassName={this.state.pageTransitionClassName}
          transitionKey={keyName}
        >
          <main
            className={classNames('mobile Expand Fxs(0)', {
              'Ov(h)': topNav || bottomNav,
              'Pt(--top-nav-bar-height)': !!topNav,
              'Pb($mobile-bottom-nav-height)': !!bottomNav,
              'Bgi($g-ds-background-primary-linear)': showBackground,
              'Bgc($c-ds-background-primary)': !showBackground,
            })}
          >
            {topNav}
            <Component {...others} {...pageProps} aside />
          </main>
          {bottomNav}
        </PageTransition>
      </>
    );
  }
}

export default Main;
